<template>

  <div :class="`nnform-element-container nnform-select ${this.error ? `has-error`: ``}`">
    <input type="hidden" :name="this.name" :value="this.modelValue">
    <div :class="`${this.activeClass} nnform-element nnform-select-menu`" @click="show">
      <div class="select-btn">
        <span class="nform-select-menu-text">{{ this.defaultText }}</span>
        <img class="bx bx-chevron-down" src="/assets/images/icons/chevron-down.svg">
      </div>

      <ul class="options">
        <li class="option" @click="reset"><span class="option-text">Сбросить</span></li>

        <li class="option" v-for="(item,index) in items" @click="select(item)">
          <!--            <img class="bx bxl-github" src="/assets/images/icons/github.svg">-->
          <span class="option-text">{{ item.name }}</span>
        </li>
      </ul>

    </div>
    <label :class="{'nnform-element-label':true,'required':required}">{{ label }}</label>
    <div v-if="this.error" class="nnform-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: "CheckoutSelect",
  data: function () {
    return {
      activeClass: '',
      value: false,
      defaultText: this.label ?? 'Выберите значение из списка',
    };
  },
  props: {
    items: Array,
    label: String,
    required: Boolean,
    name: String,
    error: String,
    modelValue: null,
  },
  methods: {
    show() {
      if (this.activeClass) {
        this.activeClass = '';
      } else {
        this.activeClass = 'active';
      }
    },
    reset() {
      this.value = false;
      this.defaultText = this.label;
      this.$emit('update:modelValue', null);
    },
    select(item) {
      this.value = item.id;
      this.defaultText = item.name;

      this.$emit('update:modelValue', item.id);
      this.$emit('refresh');
      this.$emit("unset");

    },
  },
}
</script>

<style scoped>

</style>